import { render, staticRenderFns } from "./TipoComitenteSelect.vue?vue&type=template&id=326600c4&"
import script from "./TipoComitenteSelect.vue?vue&type=script&lang=js&"
export * from "./TipoComitenteSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports